import React from 'react';
import { Link } from 'react-router-dom';
import { Section, SectionHeading } from '../ui';

const cases = [
  { title: 'LinkedIn', desc: 'Stand out to recruiters and connections.', to: '/ai-headshots-linkedin' },
  { title: 'Realtors', desc: 'Approachable, trustworthy agent photos.', to: '/ai-headshots-realtors' },
  { title: 'Executives', desc: 'Authority for bios, press, and boards.', to: '/ai-headshots-executives' },
  { title: 'Teams', desc: 'One consistent look for your whole company.', to: '/ai-headshots-teams' },
  { title: 'Job Seekers', desc: 'Make a strong first impression.', to: '/ai-headshots-job-seekers' },
];

const UseCases = () => (
  <Section className="bg-black">
    <SectionHeading
      eyebrow="Made for your profession"
      title="AI headshots for every professional"
      subtitle="Tailored styles and backgrounds for the way you work."
    />
    <div className="mt-12 grid gap-5 sm:grid-cols-2 lg:grid-cols-5">
      {cases.map((c) => (
        <Link
          key={c.title}
          to={c.to}
          className="group rounded-2xl border border-white/10 bg-white/[0.04] p-5 transition duration-200 hover:-translate-y-1 hover:border-brand/40 hover:bg-white/[0.06]"
        >
          <h3 className="text-base font-semibold text-white group-hover:text-brand-light">{c.title}</h3>
          <p className="mt-1.5 text-sm text-white/55">{c.desc}</p>
          <span className="mt-3 inline-block text-sm font-medium text-brand-light opacity-0 transition group-hover:opacity-100">
            Learn more →
          </span>
        </Link>
      ))}
    </div>
  </Section>
);

export default UseCases;
